module.exports = __webpack_public_path__ + "media/images/backgrounds/angle-top-right-inner-c61ade9921f5631aa6c98d30eb4ce80c.svg";